import {useEffect, useState} from "react";

const getWidth = () => window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

const useWindowSize = (delay = 500, immediate = true) => {
    const [width, setWidth] = useState(getWidth());

    useEffect(() => {
        let timeoutId = null;
        const resizeListener = () => {
            clearTimeout(timeoutId);
            if (immediate) setWidth(getWidth());
            timeoutId = setTimeout(() => setWidth(getWidth()), delay);
        };

        window.addEventListener('resize', resizeListener);

        return () => {
            clearTimeout(timeoutId);
            window.removeEventListener('resize', resizeListener);
        };
    }, [delay, immediate]);

    return width;
};

export default useWindowSize;
